import { Branding, DisabledPrompt, useRoute, BrandingStyle } from "bcms-react";
import { SVGAsset } from "res";
import { UtilityNavMenuItem, UtilityNavMenu } from "components/shared/views/UtilityNavView";

/**
 * @name BID1225PUtilityNavMenuItems
 * @function
 * @extends React.Component
 * @exported true
 * @description The main component for utility navigation items for BID 1225P.
 * @example
 * export default function Component() {
 *  return (
 *      <div>
 *          <BID1225PUtilityNavMenuItems/>
 *      </div>
 *  );
 * }
 */
export default function BID1225PUtilityNavMenuItems(props) {
  const navigate = useRoute();

  return (
    <Branding id="bid_abi22" value="1225P">
      <UtilityNavMenu icon="CircleProfileIcon" label="Profile" data-point="Utility_Profile">
        <BrandingStyle style={{ "backgroundColor": "utility_subnav_bg_abi22" }} className="flex-container flex-vertical" >
          <UtilityNavMenuItem label="Contact Information" route="/actContactInfo" data-point="Utility_Contact_Information" />
          <UtilityNavMenuItem label="Password" route="/password" data-point="Utility_Password" />
          <UtilityNavMenuItem label="Stopped Numbers" route="/stoppedNumbers" data-point="Utility_Stopped_Numbers" />
          <UtilityNavMenuItem label="Statement Preference" route="/statementPreference" data-point="Utility_ePeference" />
          <DisabledPrompt>
            <UtilityNavMenuItem label="Tax Documents" data-point="Utility_Tax_Documents" />
          </DisabledPrompt>
        </BrandingStyle>
      </UtilityNavMenu>
      <UtilityNavMenu icon="GearIcon" label="Settings" data-point="Utility_Settings">
        <BrandingStyle style={{ "backgroundColor": "utility_subnav_bg_abi22" }} className="flex-container flex-vertical" >
          <UtilityNavMenuItem label="Alerts" route="/notifications" data-point="Utility_Alerts" />
          <UtilityNavMenuItem label="Authorized Devices" route="/authorizedDevicesWorkflow" data-point="Utility_Authorized_Devices" />
          <UtilityNavMenuItem label="Fast Balances" route="/settingsFastBalancesWorkflow" data-point="Utility_Instance_Balances" />
          <UtilityNavMenuItem label="Authorized Apps" route="/authorizedApps" data-point="Utility_Authorized_Apps" />
          <UtilityNavMenuItem label="Accepted Disclosures" route="/acceptedDisclosuresWorkflow" data-point="Utility_Accepted_Disclosures" />
          <DisabledPrompt>
            <UtilityNavMenuItem label="Delete an Account" data-point="Utility_Delete_Account" />
          </DisabledPrompt>
        </BrandingStyle>
      </UtilityNavMenu>

      {/* messages link */}
      <div className="utility-nav-menu-header messages-link flex-container flex-horizontal align-top clickable" onClick={() => { navigate("/messages/") }} data-point="Utility_Messages">
        <div className="set-width flex-container flex-horizontal align-center">
          <SVGAsset id="EnvelopeIcon" />
        </div>
        <div className="flex-width">
          <span>Messages</span>
        </div>
        <div className="set-width text-center alert-bubble">
          <span>3</span>
        </div>
      </div>
    </Branding>
  );
}

